var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.005 2.37h-2.17v-.882c0-.555-.455-1.009-1.01-1.009-.556 0-1.01.454-1.01 1.01v.882H6.21v-.883C6.21.933 5.756.48 5.2.48c-.555 0-1.01.454-1.01 1.01v.882H2.02C.909 2.37 0 3.279 0 4.389v14.073c0 1.11.909 2.017 2.02 2.017h13.96c1.11 0 2.02-.908 2.02-2.017V4.389c.025-1.11-.884-2.018-1.995-2.018zm-.025 16.066H2.02V9.962h13.96v8.474z",
    fill: "url(#calendar_svg__paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendar_svg__paint0_linear",
    x1: 0,
    y1: 0.479,
    x2: 21.412,
    y2: 6.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#E62E78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD5630"
  })))));
}
export default __webpack_public_path__ + "static/calendar.ff4a3d27.svg";
export { SvgCalendar as ReactComponent };